import axios from '@/api/config';

const studentCourse = {
    transferClass(data) {
        return axios.put(`${process.env.BASE_URL}/studentCourse/transferClass`, data );
    },
    exportExcel(data) {
        return axios.get(`${process.env.BASE_URL}/studentCourse/exportExcel`, { params: data });
    },
    pageList(data) {
        return axios.post(`${process.env.BASE_URL}/studentCourse/pageList`, data);
    },
    studentPageList(data) {
        return axios.post(`${process.env.BASE_URL}/studentCourse/studentPageList`, data);
    },
    updateStudentCourse(data) {
        return axios.put(`${process.env.BASE_URL}/studentCourse/updateStudentCourse`, data);
    },
    deleteStudentCourse(data) {
        return axios.delete(`${process.env.BASE_URL}/studentCourse/deleteStudentCourse`, {data:data});
    },
    removeStudent(data) {
        return axios.delete(`${process.env.BASE_URL}/studentCourse/removeStudent`, {data:data});
    },
    batchAddStudent(data) {
        return axios.post(`${process.env.BASE_URL}/studentCourse/batchAddStudent`, data);
    },
}

export default studentCourse;


// WEBPACK FOOTER //
// ./src/api/studentCourse.js